import React from 'react'
import { getMyArchive } from '../../server/server'
import ArchiveList from '../archive/ArchiveList'

/**
 * The teacher's own archive: every task they answered (moods, polls, questions,
 * surveys, journals), searchable and filterable. See ArchiveList.
 */
function ArchiveTasks({ user, onGoToTasks }) {
    return (
        <div className="px-6 mb-5 flex flex-col min-h-0 xxs:max-h-[70vh] xl:max-h-[100vh] xl:h-0 xl:flex-auto">
            <ArchiveList fetchPage={getMyArchive} cacheKey={`self:${user.id}`} scrollId="scroll-inf-task" onGoToTasks={onGoToTasks} className="archive--panel" />
        </div>
    )
}

export default ArchiveTasks
